import { buildQuery } from 'legacy/libs/utils'

export function parametrize(url, params) {
  const query = buildQuery(params)

  if (!query) {
    return url
  }

  return `${url}?${query}`
}

export function browseEntry(entryPk, params) {
  return parametrize(`/browse/${entryPk}/`, params)
}

export function downloadEntry(entryPk, { showDrafts, ...rest }) {
  return parametrize(`/api/download/entry/${entryPk}`, {
    showDrafts: showDrafts ? 1 : 0,
    ...rest,
  })
}

export function browseSearch(params) {
  return parametrize('/browse/search', params)
}

export function contribute(params) {
  return parametrize('/contribute/', params)
}

export function questionnaire(entryPk, pollPk, params) {
  const baseUrl = `/questionnaire/${entryPk}/`

  if (pollPk) {
    return `${baseUrl}${pollPk}/`
  }

  return parametrize(baseUrl, params)
}

export function publicProfile(username, params) {
  return parametrize(`/accounts/${username}/`, params)
}

export function downloadEmptyPoll(pollPk, params) {
  return parametrize(`/api/download/poll/${pollPk}`, params)
}

export function downloadCsv(entryPk, expertPk, params) {
  return parametrize('/search/', {
    ...params,
    e: expertPk,
    r: entryPk,
    csv: true,
  })
}

export function dashboard(params) {
  return parametrize('/accounts/dashboard/', params)
}

export function editorConsole(params) {
  return parametrize('/accounts/editor-console/', params)
}

export function downloadBib(entryPk) {
  return parametrize(`/api/polls/entry/${entryPk}/bibtex/${entryPk}/`)
}

export function downloadBibForSearch(pk) {
  return parametrize(`/api/polls/search_request/${pk}/answer_sets/bibtex/`)
}
